module.exports = __webpack_public_path__ + "static/media/wood_by_EricHart3d.a61a0d2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phaser-assets/textures/wood_by_EricHart3d.png
// module id = 990
// module chunks = 0